export interface Country {
  id: number;
  name: string;
}

export enum ProductConditionCode {
  new = 1,
  used = 2,
  refit = 3,
  notApplicable = 4
}

export enum CurrencyCode {
  usd = 840,
  eur = 978
}

export enum UrgencyCode {
  emergency = 1,
  nextDay = 2,
  twoThreeDays = 3,
  fourSixDays = 4,
  thisWeek = 5,
  nextWeek = 6,
  any = 7
}

export interface Money {
  id: CurrencyCode;
  value: number;
}

class ProductConditions {
  private readonly map = {} as any;

  constructor() {
    this.map[ProductConditionCode.new] = "new";
    this.map[ProductConditionCode.used] = "used";
    this.map[ProductConditionCode.refit] = "refit";
    this.map[ProductConditionCode.notApplicable] = "notApplicable"
  }

  productCondition = (code: ProductConditionCode) => {
    return this.map[code] || '';
  };
}

export const { productCondition } = new ProductConditions();

export enum MeasurementUnitCode {
  pieces = 1,
  sets = 2,
  liters = 3,
  milliliters = 4,
  gallons = 5,
  cubicMeters = 6,
  pressure = 7,
  kilograms = 8,
  grams = 9,
  pounds = 10
}

class MeasurementUnit {
  private readonly map = {} as any;

  constructor() {
    this.map[MeasurementUnitCode.pieces] = "pcs";
    this.map[MeasurementUnitCode.sets] = "sets";
    this.map[MeasurementUnitCode.liters] = "l";
    this.map[MeasurementUnitCode.milliliters] = "ml";
    this.map[MeasurementUnitCode.gallons] = "gal";
    this.map[MeasurementUnitCode.cubicMeters] = "m³";
    this.map[MeasurementUnitCode.pressure] = "psi";
    this.map[MeasurementUnitCode.kilograms] = "kg";
    this.map[MeasurementUnitCode.grams] = "g";
    this.map[MeasurementUnitCode.pounds] = "lbs";
  }

  unitCode = (code?: MeasurementUnitCode) => {
    if (!code) {
      return '';
    }
    return this.map[code] || '';
  };
}

export const sortedMeasurementUnits = [
  MeasurementUnitCode.grams,
  MeasurementUnitCode.gallons,
  MeasurementUnitCode.kilograms,
  MeasurementUnitCode.liters,
  MeasurementUnitCode.pounds,
  MeasurementUnitCode.cubicMeters,
  MeasurementUnitCode.milliliters,
  MeasurementUnitCode.pieces,
  MeasurementUnitCode.pressure,
  MeasurementUnitCode.sets
];

export const { unitCode } = new MeasurementUnit();
